/** Round icon shown above a heading on confirmation screens. */
export function StatusBadge({ kind }: { kind: 'mail' | 'check' | 'alert' }) {
  const tone = kind === 'alert' ? 'bg-down-bg text-down' : kind === 'check' ? 'bg-up-bg text-up' : 'bg-accent-bg text-accent-fg';
  return (
    <span className={`mb-6 grid size-14 place-items-center rounded-full ${tone}`} aria-hidden="true">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        {kind === 'mail' && (
          <>
            <rect x="2" y="4" width="20" height="16" rx="2" />
            <path d="m22 7-10 6L2 7" />
          </>
        )}
        {kind === 'check' && <path d="M20 6 9 17l-5-5" />}
        {kind === 'alert' && (
          <>
            <circle cx="12" cy="12" r="10" />
            <path d="M12 8v4M12 16h.01" />
          </>
        )}
      </svg>
    </span>
  );
}
